<div class="caption-bar">
  <div class="caption">Abwesenheitsanträge</div>
  <ion-button (click)="openAbsenceFormModal(null)">
    <ion-icon size="large" name="add"></ion-icon>
  </ion-button>
</div>

<lib-absence-overview
  (selectedWorkerChanged)="selectedUser = $event"
></lib-absence-overview>
